module.exports = __webpack_public_path__ + "static/graph1desktop-52ffb5937cb7cd94d584951e9cf21590.png";